import UsersPageLayout from './components/UsersPageLayout';
import TopSearchBar from './components/TopSearchBar';
import FiltersSidebar from './components/FiltersSidebar';
import ViewData from './components/ViewData';
import { UserRoundSearch } from 'lucide-react';
import { LayoutPage } from '@/components/hoc';
import { useDocumentTitle } from '@/hooks';

const UsersPage = () => {

  useDocumentTitle({ title: 'Utilisateurs' });

  return (
    <LayoutPage
      header={{
        description: 'Recherche et gestion des comptes utilisateurs.',
        title: 'Utilisateurs'
      }}
      breadcrumb={{ title: 'Utilisateurs' }}
      icon={UserRoundSearch}>
      <UsersPageLayout
        topBar={<TopSearchBar />}
        sidebar={<FiltersSidebar />}
        content={<ViewData />}
      />
    </LayoutPage>
  );

};

export default UsersPage;
